// How the slim "Data source" line under a ticker and the "Verify source files" card
// further down the page talk to each other, without the big edit page having to carry
// the state between them.

export const SOURCE_SAVED = "indxx:source-saved";
export const VERIFY_SOURCE = "indxx:verify-source";

// A ticker's data source was just saved: the card reloads that ticker's settings.
export const emitSourceSaved = (indexCode: string, dataSource: string) =>
  window.dispatchEvent(new CustomEvent(SOURCE_SAVED, { detail: { indexCode, dataSource } }));

// "Verify now": the card selects that ticker, scrolls into view and highlights itself.
export const requestVerify = (indexCode: string) =>
  window.dispatchEvent(new CustomEvent(VERIFY_SOURCE, { detail: { indexCode } }));

export const SOURCE_CHOOSE = "indxx:source-choose";

// Solactive was picked in the Data source field but has no login yet: the card opens its
// connection form so the login can be typed there, once, and saved from there.
export const emitSourceChoose = (indexCode: string, dataSource: string) =>
  window.dispatchEvent(new CustomEvent(SOURCE_CHOOSE, { detail: { indexCode, dataSource } }));
